import {
  SimpleGrid,
  Flex,
  Text,
  Skeleton,
  Box,
  GridItem,
  Button,
} from "@chakra-ui/react";
import { numberToCurrency, trackEvent } from "utils";
import { Section } from "../utils";
import BaseImage from "@components/BaseImage";
import UTMLink from "@components/UTMLink";
import { LP_GAIN, LP_RESTAKE } from "@constants/analytics";
import useTotalTVL from "@hooks/useTotalTvl";
// import { useState } from "react";

const Hero = () => {
  const { isLoadingTotalTvl, totalStaked } = useTotalTVL();
  // const [isVisible, setIsVisible] = useState(false);

  // const tooltipRef = useRef<HTMLDivElement>(null);

  // Close tooltip on outside click
  // useOutsideClick({
  //   ref: tooltipRef,
  //   handler: () => setIsVisible(false),
  // });

  return (
    <Section>
      <SimpleGrid
        spacing={{ base: "32px", md: "48px" }}
        columns={{ sm: 1, md: 2 }}
        alignItems="center"
      >
        <GridItem order={{ base: 2, md: 1 }}>
          <Flex
            flexDir="column"
            gap={{ base: "24px", md: "80px" }}
            alignItems={{ base: "center", md: "flex-start" }}
            textAlign={{ base: "center", md: "left" }}
          >
            <Flex flexDir="column" gap="24px">
              <Flex flexDir="column" gap={{ base: "6px", md: "12px" }}>
                <Text
                  fontWeight={{ base: "600", md: "500" }}
                  fontSize={{ base: "40px", sm: "56px", lg: "64px" }}
                  lineHeight="115%"
                  color="#3A3636"
                  letterSpacing="-2.14px"
                >
                  Maximize ETH <br /> Earnings with Kelp & Gain
                </Text>
                <Text
                  letterSpacing="-1.4px"
                  fontSize={{ base: "20px", md: "36px" }}
                  lineHeight="120%"
                  fontWeight="400"
                  color="textPrimary"
                >
                  Restake & Earn on 10 chains
                </Text>
              </Flex>

              <Flex
                alignItems="center"
                justifyContent={{ base: "center", md: "flex-start" }}
                gap={{ base: "8px", md: "24px" }}
              >
                <UTMLink
                  href="/restake"
                  _hover={{
                    borderBottom: "none",
                  }}
                  onClick={() => {
                    trackEvent(LP_RESTAKE, {
                      triggerer: "hero",
                    });
                  }}
                  w={{ base: "98px", md: "170px" }}
                  alignSelf={{ base: "center", md: "auto" }}
                >
                  <Button
                    w="100%"
                    variant="unstyled"
                    borderRadius="52px"
                    h={{ base: "46px", md: "72px" }}
                    fontSize={{ base: "12px", md: "18px" }}
                    fontWeight="600"
                    lineHeight="120%"
                    color="#FFF"
                    bg="textPrimary"
                  >
                    Restake
                  </Button>
                </UTMLink>

                <UTMLink
                  href="/gain"
                  _hover={{
                    borderBottom: "none",
                  }}
                  onClick={() => {
                    trackEvent(LP_GAIN, {
                      triggerer: "hero",
                    });
                  }}
                  w={{ base: "124px", md: "210px" }}
                  alignSelf={{ base: "center", md: "auto" }}
                >
                  <Button
                    w="100%"
                    variant="unstyled"
                    borderRadius="52px"
                    h={{ base: "46px", md: "72px" }}
                    fontSize={{ base: "12px", md: "18px" }}
                    fontWeight="600"
                    lineHeight="120%"
                    color="textPrimary"
                    bg="transparent"
                    border="2px"
                    borderColor="#A1B6BA"
                  >
                    Explore Gain
                  </Button>
                </UTMLink>
              </Flex>
            </Flex>

            <Flex alignItems="center" gap={{ base: "24px", md: "80px" }}>
              {/* TVL */}
              <Flex
                flexDir="column"
                gap={{ base: 0, md: "8px" }}
                alignItems={{ base: "center", md: "flex-start" }}
              >
                <Box
                  color="textPrimary"
                  fontSize={{ base: "16px", md: "44px" }}
                  lineHeight="120%"
                  fontWeight={{ base: "600", md: "600" }}
                >
                  {isLoadingTotalTvl ? (
                    <Skeleton height="52px" w="90px" />
                  ) : totalStaked ? (
                    <Text>{`$${numberToCurrency(
                      totalStaked.toString()
                    )}`}</Text>
                  ) : (
                    "-"
                  )}
                </Box>

                <Flex gap={{ base: "4px", md: "8px" }} alignItems="center">
                  <Text
                    fontSize={{ base: "12px", md: "20px" }}
                    lineHeight="120%"
                    fontWeight="500"
                    color="textSecondary"
                  >
                    TVL
                  </Text>
                  {/* {!isLoadingTotalTvl && totalStaked ? (
                    <Box fontSize="20px" ref={tooltipRef}>
                      <Tooltip
                        placement="bottom"
                        backgroundColor="#075A5A"
                        borderRadius="8px"
                        p="8px 16px"
                        pointerEvents="all"
                        isOpen={isVisible}
                        closeDelay={2000}
                        onClose={() => setIsVisible(false)}
                        label={
                          <Flex flexDir="column" gap="8px" w="160px">
                            <Text
                              fontSize={{ base: "14px", md: "20px" }}
                              color="#FFF"
                              fontWeight="600"
                            >
                              TVL
                            </Text>
                            <Flex
                              flexDir="column"
                              fontSize={{ base: "12px", md: "14px" }}
                              color="#A1B6BA"
                              fontWeight="400"
                              lineHeight="20px"
                            >
                              <Flex items-center justify="space-between">
                                {restakeTvl && (
                                  <>
                                    <Text>Restake TVL</Text>
                                    <Text>
                                      {`$${numberToCurrency(
                                        restakeTvl?.toString()
                                      )}`}
                                    </Text>
                                  </>
                                )}
                              </Flex>
                              <Flex items-center justify="space-between">
                                <Text>Gain TVL</Text>
                                {`$${numberToCurrency(gainTvl.toString())}`}
                              </Flex>
                            </Flex>
                          </Flex>
                        }
                      >
                        <Box fontSize={{ base: "12px", md: "20px" }}>
                          <AiOutlineInfoCircle
                            onMouseEnter={() => setIsVisible(true)}
                            onClick={() => setIsVisible(true)}
                          />
                        </Box>
                      </Tooltip>
                    </Box>
                  ) : null} */}
                </Flex>
              </Flex>

              {/* APY */}
              <Flex
                flexDir="column"
                gap={{ base: 0, md: "8px" }}
                alignItems={{ base: "center", md: "flex-start" }}
              >
                <Box
                  color="textPrimary"
                  fontSize={{ base: "16px", md: "44px" }}
                  lineHeight="120%"
                  fontWeight={{ base: "600", md: "600" }}
                >
                  20%
                </Box>

                <Text
                  fontSize={{ base: "12px", md: "20px" }}
                  lineHeight="120%"
                  fontWeight="500"
                  color="textSecondary"
                >
                  Earn upto APR
                </Text>
              </Flex>
            </Flex>
          </Flex>
        </GridItem>

        <GridItem order={{ base: 1, md: 2 }}>
          <Box w="100%" h={{ base: "240px", md: "650px" }} pos="relative">
            <BaseImage
              src="/assets/landing_hero.svg"
              layout="fill"
              objectFit="contain"
              alt="hero"
            />
          </Box>
        </GridItem>
      </SimpleGrid>
    </Section>
  );
};

export default Hero;
